import vtkResourceLoader from '@kitware/vtk.js/IO/Core/ResourceLoader';

import {getDracoDecoderUrl, getDracoWrapperUrl} from '../api/urls';

import vtkDracoReader from './vtkDracoReader';

async function initializeDracoReader() {
	await vtkResourceLoader.loadScript(getDracoWrapperUrl());
	await vtkDracoReader.setWasmBinary(
		getDracoDecoderUrl(),
		'draco_decoder.wasm',
	);
}

const initializeDracoReaderPromise = initializeDracoReader();

export default initializeDracoReaderPromise;
